import { render, staticRenderFns } from "./MenuLinkList.vue?vue&type=template&id=a542011c"
import script from "./MenuLinkList.vue?vue&type=script&lang=js"
export * from "./MenuLinkList.vue?vue&type=script&lang=js"
import style0 from "./MenuLinkList.vue?vue&type=style&index=0&id=a542011c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports